// @flow
/* eslint-env browser */

import { defineCustomElement } from '../../define-custom-element';
import { LIB_VERSION } from '../../version';
import { DisplayAdComponent } from '../independent.co.uk/component';

window.localStorage.setItem('standard-display-version', `independent.co.uk/${LIB_VERSION}`);
DisplayAdComponent.adUnit = '/71347885/_main_eveningstandard/es_arkadium';

defineCustomElement(DisplayAdComponent);
